// This file contains the settings of the appConfig that needs to be overridden when the application is run in development.

export const appConfig = {
    // CyberGate Management Portal front-end Local clientId and apiScope
    azureAdMsalClientId: '48d26059-6dc3-4367-a1af-ea6418ab4e07',
    azureAdMsalApiScope: 'https://admin.robin.nl/api/Tenant.Read',

    // Entra External ID (CIAM) settings
    ciamMsalClientId: 'f968a5e5-1e9c-4244-9228-91a16028f0e7',
    ciamMsalApiScope: 'api://d5767565-1d2b-4946-b833-a634cdead438/App.Acces',
};
